










import { computed, defineComponent, PropType, ref, watch } from "@nuxtjs/composition-api";
import { GenericObjectType } from "~/utils/types";
export default defineComponent({
    props:{
        isOn: {
            type: Boolean,
            default:false
        },
        trueValue:{
            type: null as PropType<any>,
            default: "true"
        },
        falseValue:{
            type: null as PropType<any>,
            default: "false"
        },
        styles:{
          type: Object as PropType<GenericObjectType>,
            default : ()=>{return {} as GenericObjectType}
        },
        disabled:{
          type: Boolean,
          default:false
        }
    },
  setup(props){
    
    const switchModel = ref<any>(props.isOn?props.trueValue:props.falseValue)
    const isOn = computed(()=>props.isOn)
    watch(isOn, ()=>{  switchModel.value = props.isOn?props.trueValue:props.falseValue})
    return {switchModel}
  }
});
